import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatMoney } from '../utils'

export const mwmRevenuePerUserDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'revenuePerFreeTrialLifetimeAvg',
      field: 'mwm_revenue_per_free_trial_lifetime',
      headerName: 'Revenue per FreeTrial Lifetime',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmEltvPerFreeTriald10Avg',
      field: 'mwm_eltv_d10_per_freetrial_lifetime',
      headerName: 'eLTV D10 per FreeTrial Lifetime',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'revenuePerSubscriberLifetimeAvg',
      field: 'mwm_revenue_per_subscriber_lifetime',
      headerName: 'Revenue per Subscriber Lifetime',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmEltvPerSubscriberd10Avg',
      field: 'mwm_eltv_d10_per_subscriber_lifetime',
      headerName: 'eLTV D10 per Subscriber Lifetime',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'revenuePerPayingUserLifetimeAvg',
      field: 'mwm_revenue_per_paying_user_lifetime',
      headerName: 'Revenue per Paying Lifetime',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmEltvPerPayingd10Avg',
      field: 'mwm_eltv_d10_per_paying_lifetime',
      headerName: 'eLTV D10 per Paying Lifetime',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'lightGreyFill',
  headerName: 'MWM Revenue per User',
}
